import { Box, Typography } from '@mui/material';
import { useEffect, useMemo, useRef, useState } from 'react';
import { getLinkStyles, getNavMenuStyles } from './LocationNavMenu.styles';
import { getNavItemStyles } from '@shared-components/components/Header/NavigationBar/NavigationBarItem/NavigationBarItem.styles';
import TAGLink from '@shared-components/components/TAGLink';
import { useAppContext, useFacilityContext } from '@shared-components/context';
import { FacilityDetailsPageContentData, getFacilityDetailsPageContentDataByFacilityId } from '@shared-components/services/getFacilityDetailsPageContentDataByFacilityId';
import { generateLovetODPLinks } from '@utils/location-nav-menu';
interface IProps {
  isMobile?: boolean;
}
export default function LocationNavMenu({
  isMobile
}: Readonly<IProps>) {
  const {
    officeInfo
  } = useFacilityContext();
  const {
    config,
    environment
  } = useAppContext();
  const [facilityDetailsPage, setFacilityDetailsPage] = useState<FacilityDetailsPageContentData | null>(null);
  const fetchedFacilityIdRef = useRef<string | null>(null);
  const facilityId = officeInfo?.code;
  useEffect(() => {
    if (!facilityId || fetchedFacilityIdRef.current === facilityId) {
      return;
    }
    let isMounted = true;
    const contentfulGraphqlURL = environment === 'prod' ? config.services.prod.CONTENTFUL_GRAPHQL_URL : config.services.nonprod.CONTENTFUL_GRAPHQL_URL;
    (async () => {
      let data;
      try {
        data = await getFacilityDetailsPageContentDataByFacilityId(facilityId, contentfulGraphqlURL);
      } catch {
        data = null;
      }
      // Only mark as fetched once the request has actually completed, so an interrupted
      // effect (e.g. React Strict Mode's mount/unmount/remount in dev) retries instead of
      // getting permanently stuck.
      if (isMounted) {
        fetchedFacilityIdRef.current = facilityId;
        setFacilityDetailsPage(data);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [facilityId, environment, config.services.prod.CONTENTFUL_GRAPHQL_URL, config.services.nonprod.CONTENTFUL_GRAPHQL_URL]);

  // generateLovetODPLinks falls back to default links when facilityDetailsPage (jump links)
  // hasn't resolved yet, so office info alone is enough to render immediately without a skeleton.
  const locationLinks = useMemo(() => officeInfo?.address ? generateLovetODPLinks(officeInfo.address, config, facilityDetailsPage) : [], [officeInfo, config, facilityDetailsPage]);
  if (!officeInfo?.address) {
    return null;
  }
  return <Box sx={getNavMenuStyles(isMobile)} data-sentry-element="Box" data-sentry-component="LocationNavMenu" data-sentry-source-file="LocationNavMenu.tsx">
			{locationLinks.map(item => item ? <TAGLink href={item.path} key={`location-navigation-link-${item.id}`} linkSx={{
      ...(!isMobile && getNavItemStyles()),
      ...getLinkStyles(isMobile)
    }}>
						<Typography variant="bodyMediumSemiBold" color="text.interactive" data-testid={`link_location_${item.id}`}>
							{item.title}
						</Typography>
					</TAGLink> : null)}
		</Box>;
}